/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React from "react"
import TopHeader from "../../components/TopHeader"
import { useSelector,useDispatch } from "react-redux"
import { useEffect,useCallback,useContext ,useState} from "react"
import { useLocation,useSearchParams } from "react-router-dom"
import { useEditUserMutation } from "../../features/apiSlice"
import Debounce from "../../CommonMethods/Debounce"
import { limitReducer, resetArrays } from "../../redux/MultiselectRows"
import Table from "./Components/Table"
import TopBar from "../../components/TopBar"
import Pagination from "../../components/Pagination"
import Limit from "../../components/Limit"
import GlobalContext from "../../components/Context/GloablContext"
import CustomOverLay from "../../components/CustomOverLay"
import { useExportUsersMutation } from "../../features/apiSlice"
import {useGetUsersQuery} from "../../features/apiSlice"
import SearchEmptyScreen from "../../components/SearchEmptyScreen"
import Emptyscreen from "../../components/EmptyScreen"
import ConfirmationPrompt from "../../components/ConfirmationPrompt"
import AnimatedModel from "../../components/Animation/AnimatedModel"
import AdminCorporateAdvanceSearch from "../../components/Layout/AdvancedSearch"
import { useAdminOrCorporateSearch } from "../../components/Context/adminCorporateSearch"
import { convertDatesToEpochUTC } from "../../CommonMethods/ConvertFilterDatetoEpochUtcFormat"
import { handleSidebarPrvState } from "../../redux/systemConfigSlice"


export default function ManageAdminAndCoporateUser(){
    const {setToastmessage,Toastmessage,toastErrorMessage,setToastErrorMessage,isSideBar,setIsSideBar,isAdvancedSearchOpen,setIsAdvancedSearchOpen} = useContext(GlobalContext);
    
    const [editUser]=useEditUserMutation()
    const [exportUsers]=useExportUsersMutation()
    const [suggestions,setSuggestions]=useState("")
    const [limit,setLimit]=useState("15")
    const [skip,setSkip]=useState(true)
    const [isColumnSelect,setIsColumnSelect] = useState(false)
    const location=useLocation()
    const dispatch=useDispatch()
    const [searchParams, setSearchParams] = useSearchParams({});
    const [loading,setLoading]=useState(false)
    const [isSortselected,setisSortSelected]=useState(false)
    const selectedRows=useSelector(state=>state?.MultiSelectSlice?.selectedRows?.selectedIds)
    const [confirmationState, setConfirmationState] = useState({isOpen:false,rowData:'',multirow:'',user_names:[]});
    const [textAreaMsg,setTextAreaMsg]=useState('')
    const [emptyField,setEmptyField]=useState(false);
    const auth=useSelector(state=>state?.auth)
    const userType=localStorage?.getItem('user_type')!==null?localStorage.getItem('user_type'):sessionStorage.getItem('user_type')
     

    const { advancedAdminCorSearch, setAdvancedAdminCorSearch } = useAdminOrCorporateSearch();

    // const [trigger, result, lastPromiseInfo] = useLazyGetUsersQuery({refetchOnFocus:false });

    const {data,isFetching,isLoading,status}=useGetUsersQuery(searchParams?.toString(),{skip: skip||location.search===''})
    /**
     * The function `handleSearchParams` updates the search parameters by setting the value of a
     * specific key and value, and then updating the search parameters state.
     */
    const handleSearchParams = (key, value) => {
        let params = Object.fromEntries(searchParams);
        // Only reset page_number to 1 if we're not explicitly setting page_number
        if (key !== 'page_number') {
            params.page_number = 1
        }
        if(key === 'search') {params[key] = encodeURIComponent(value); }
        else params[key] = value
        if (params.search === '') delete params.search
        setSearchParams({ ...params})
    }
    
    
    useEffect(() => {

        if (location.search === '') {
            setSkip(true);  // Handle empty query scenario
        }

        // If there is a valid state object in location
        if (location.state !== null && location.state !== '' && !Array.isArray(location.state)) {
            const params = { limit: '15', page_number: '1', sort: 'created_at+desc', ...location.state }
            if (params.search) params.search = decodeURIComponent(params.search)
            else delete params.search
            setSearchParams(params)
            if (params.search_mode && !isAdvancedSearchOpen) {
                dispatch(handleSidebarPrvState(isSideBar))
                setIsAdvancedSearchOpen(true)
                setIsSideBar(false)
            }
        } else {
            // Only initialize default values if no search params exist
            const params = Object.fromEntries(searchParams)
            let changed = false
            if (!params.limit) { params.limit = '15'; changed = true }
            if (!params.page_number) { params.page_number = '1'; changed = true }
            if (!params.sort) { params.sort = 'created_at+desc'; changed = true }
            if (changed) setSearchParams(params, { replace: true })
        }

        // Set suggestions based on the search query
        setSuggestions(
            searchParams.get('search')
                ? decodeURIComponent(searchParams.get('search'))
                : ''
        );

    }, [location]);


    useEffect(()=>{
        if(searchParams.size>=3){
            setSkip(false)
        }
        else{
            setSkip(true)
        }
    },[searchParams])

 
   
    function handleNoOfRowsClick(number) {
        let params = Object.fromEntries(searchParams);
        params.page_number = 1;
        params["limit"] = number;
        setSearchParams({ ...params });
    }
    const handleOnClickPageNumber = (pageNum) => {
        setisSortSelected(false)
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum })
       
    }

    useEffect(() => {
        if(data!==undefined){
            dispatch(limitReducer([data,searchParams.get("limit"),searchParams.get("page_number")]))
        }
    }, [data?.data]);

    const handleChange = (val) => {
        handleSearchParams('search', val)
        
    };

    const optimizedFn = useCallback(
        Debounce((value) => handleChange(value)),
        [searchParams]
    );

    /**
     * The function sets the confirmation state to an empty object when a confirmation click event
     * occurs.
     */
    const handleConformationClick = () => {
        setEmptyField(false)
        setTextAreaMsg("")
        setConfirmationState({});
    }

    /**
     * This function handles the activation of a user account and updates the user list accordingly.
     */
    const handleOnCLickActivate = async(e) => {
        
        if((confirmationState?.rowData!==undefined&&confirmationState?.rowData!==""&&confirmationState?.rowData?.status === 'active' && textAreaMsg.trim()=== '')||(confirmationState?.multirow==="deactive"&&(textAreaMsg.trim()===''))){ 
            setToastErrorMessage('Please fill in the mandatory field')
            
            setEmptyField(true)
            return;
        }
        try {
            let body = { }
            if(confirmationState?.rowData!==undefined&&confirmationState?.rowData!==""){
                {confirmationState?.rowData?.status === 'inactive' ?
                    body={
                        "user_name": [confirmationState?.rowData.user_name],
                        "status":confirmationState?.rowData?.status==="inactive"?"active":"inactive",
                        "note" : ''
                    } : 
                    body={
                        "user_name": [confirmationState?.rowData.user_name],
                        "status":confirmationState?.rowData?.status==="inactive"?"active":"inactive",
                        "note" : textAreaMsg 
                    } 
                }
            }
            else{
                confirmationState?.multirow==="deactive"?
                    body={
                        "user_name": (selectedRows?.filter((user)=>user.status!=='inactive'))?.map((item)=>item.name),
                        "status":confirmationState?.multirow==="deactive"?"inactive":"active",
                        "note" : textAreaMsg 
                    }
                    :
                    body={
                        "user_name": (selectedRows?.filter((user)=>user.status!=='active'))?.map((item)=>item.name),
                        "status":confirmationState?.multirow==="deactive"?"inactive":"active",
                        "note" : ''
                        
                    }
            }
            setLoading(true)
            
            
            const activationRes=await editUser({body})
            setLoading(false)
            
            if(activationRes?.error){
                setToastErrorMessage(activationRes?.error?.data?.message)
            }else{
                if(confirmationState?.multirow!==""&&confirmationState?.multirow!==undefined){
                    setToastmessage(`Admin/Corporate Users ${confirmationState?.multirow ==="active"?"activated":"deactivated"} successfully`);
                }
                else{
                    setToastmessage(`${confirmationState?.rowData?.user_type==="admin-user"?'Admin ':'Corporate '}User ${confirmationState?.rowData?.status==="inactive"?"activated":"deactivated"} successfully`);
                }
                
            }
            setTextAreaMsg('');
            dispatch(resetArrays())
            setConfirmationState({})
           
        } catch (error) {
            setConfirmationState({});
            setToastErrorMessage('Something went wrong. Please try again')
        }
    }  
        
    const handleOnSubmit = (e) => {
        e.preventDefault();
        let searchString = '';
    
        
        // Utility function to handle __NULL__ logic for search values
        const formatSearchValue = (value) => {
            const trimmedValue = value.trim();
            return trimmedValue === '-' ? '__NULL__' : trimmedValue;
        };

        // Check for `user_id` and `user_id_inverse` conditions
        if (advancedAdminCorSearch?.user_id && advancedAdminCorSearch.user_id.trim()!=='') {
            const userIdPrefix = advancedAdminCorSearch.user_id_inverse ? 'ne:' : '';
            const formattedUserId = formatSearchValue(advancedAdminCorSearch.user_id);
            searchString += `user_id=${userIdPrefix}${encodeURIComponent(formattedUserId)};`;
        }

        // Check for `first_name` and `first_name_inverse` conditions
        if (advancedAdminCorSearch?.first_name && advancedAdminCorSearch.first_name.trim()!=='') {
            const firstNamePrefix = advancedAdminCorSearch.first_name_inverse ? 'ne:' : '';
            const formattedFirstName = formatSearchValue(advancedAdminCorSearch.first_name);
            searchString += `first_name=${firstNamePrefix}${encodeURIComponent(formattedFirstName)};`;
        }

        // Check for `last_name` and `last_name_inverse` conditions
        if (advancedAdminCorSearch?.last_name && advancedAdminCorSearch.last_name.trim()!=='') {
            const lastNamePrefix = advancedAdminCorSearch.last_name_inverse ? 'ne:' : '';
            const formattedLastName = formatSearchValue(advancedAdminCorSearch.last_name);
            searchString += `last_name=${lastNamePrefix}${encodeURIComponent(formattedLastName)};`;
        }

        // Check for `user_name` and `user_name_inverse` conditions
        if (advancedAdminCorSearch?.user_name || advancedAdminCorSearch.user_name_domain) {
            const userNamePrefix = advancedAdminCorSearch.user_name_inverse ? 'ne:' : '';
            const userName = formatSearchValue(advancedAdminCorSearch.user_name || '');
            const userNameDomain = formatSearchValue(advancedAdminCorSearch.user_name_domain || '');
            searchString += `user_name=${userNamePrefix}${encodeURIComponent(userName)}@${encodeURIComponent(userNameDomain)};`;
        }

        // Check for `email_address` and `email_address_inverse` conditions
        if (advancedAdminCorSearch?.email_address || advancedAdminCorSearch.email_address_domain) {
            const emailAddressPrefix = advancedAdminCorSearch.email_address_inverse ? 'ne:' : '';
            const emailAddress = formatSearchValue(advancedAdminCorSearch.email_address || '');
            const emailAddressDomain = formatSearchValue(advancedAdminCorSearch.email_address_domain || '');
            searchString += `email_address=${emailAddressPrefix}${encodeURIComponent(emailAddress)}@${encodeURIComponent(emailAddressDomain)};`;
        }

        // Check for `mobile_number` and `mobile_number_inverse` conditions
        if (advancedAdminCorSearch?.mobile_number_code || advancedAdminCorSearch.mobile_number) {
            const mobileNumPrefix = advancedAdminCorSearch.mobile_number_inverse ? 'ne:' : '';
            const mobileCountryCode = formatSearchValue(advancedAdminCorSearch.mobile_number_code || '');
            const mobileNumber = formatSearchValue(advancedAdminCorSearch.mobile_number || '');
            searchString += `country_code2-mobile_number=${mobileNumPrefix}${mobileCountryCode ? '+' : ''}${encodeURIComponent(mobileCountryCode)}-${encodeURIComponent(mobileNumber)};`;
        }

        // Check for `main_number` and `main_number_inverse` conditions
        if (advancedAdminCorSearch?.main_number_code || advancedAdminCorSearch.main_number) {
            const mainNumPrefix = advancedAdminCorSearch.main_number_inverse ? 'ne:' : '';
            const mainCountryCode = formatSearchValue(advancedAdminCorSearch.main_number_code || '');
            const mainNumber = formatSearchValue(advancedAdminCorSearch.main_number || '');
            searchString += `country_code1-main_number=${mainNumPrefix}${mainCountryCode ? '+' : ''}${encodeURIComponent(mainCountryCode)}-${encodeURIComponent(mainNumber)};`;
        }

        // Handle `user_type` with optional inverse condition
        if (Array.isArray(advancedAdminCorSearch.user_type)) {
            const userTypePrefix = advancedAdminCorSearch.user_type_inverse ? 'ne:' : ''; 
            advancedAdminCorSearch.user_type.forEach(type => {
                searchString += `user_type=${userTypePrefix}${encodeURIComponent(type)};`;
            });
        }
        // Handle `status` with optional inverse condition
        if (Array.isArray(advancedAdminCorSearch.status)) {
            const userStsPrefix = advancedAdminCorSearch.status_inverse ? 'ne:' : ''; 
            advancedAdminCorSearch.status.forEach(type => {
                searchString += `status=${userStsPrefix}${encodeURIComponent(type)};`;
            });
        }

        const { created_day, created_month, created_year } = advancedAdminCorSearch || {};
        // Check if only some of the fields are filled
        const isPartialDateFilled = (created_day && (!created_month || !created_year)) || (created_month && (!created_day || !created_year)) || (created_year && (!created_day || !created_month));

        if (isPartialDateFilled) {
            setEmptyField(true) 
            return;       
        } else if (created_day && created_month && created_year) {
            // Ensure date is in 'YYYY-MM-DD' format
            const dateStr = `${created_year}-${String(created_month).padStart(2, '0')}-${String(created_day).padStart(2, '0')}`;

            // Create a Date object at midnight (00:00:00)
            const date = new Date(`${dateStr}T00:00:00`);

            // Convert to epoch time in seconds
            const epochDate = Math.floor(date.getTime() / 1000);
            const createdDatePrefix = advancedAdminCorSearch.created_date_inverse ? 'ne:' : ''; 

            // Add epoch to search string
            searchString += `created_at=${createdDatePrefix}${epochDate};`;
        }        

        // Remove trailing ';' if present
        searchString = searchString.endsWith(';') ? searchString.slice(0, -1) : searchString;
        
        // Merge all search parameters into a single object
        const currentParams = Object.fromEntries(searchParams); // Get existing params
        const newParams = {
            ...currentParams, // Preserve existing params (limit, sort, etc.)
            search: searchString || '', // Add search string
            search_mode: advancedAdminCorSearch.match === false ? 'and' : 'or', // Add search mode
            page_number: 1, // Reset page number on new search
            sort: currentParams.sort || 'created_at+desc', // Keep sort or set default
            limit: currentParams.limit || '15', // Keep limit or set default
        };
    
        // Remove empty search key if search string is empty
        if (!newParams.search) delete newParams.search;
    
        // Update all searchParams in one go to avoid multiple re-renders or API calls
        setSearchParams(newParams);
    };
     

    return(
        <>
            <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden'>
                <TopHeader title={"Manage Admin/Corporate Users"}/>
                <div className='bg-white rounded-lg pt-3 h-customh3 relative'>
                    <div className="px-6">
                        <TopBar 
                            title={'List of Admin/Corporate Users'}
                            path={'/manage-admin-corporate/add-admin-corporate'}
                            AddButton={(data===undefined||userType==="corporate-user") ? false : true}
                            SearchInput={((data?.data?.length===0 &&searchParams.get("search")===null) ||data===undefined) ? false : true}
                            SearchPlaceholder={'Search for ID,Username etc'}
                            buttonName={"Add User"}
                            menuBar={(data!==undefined&&data?.data?.length>0&&selectedRows?.length>0) ? true : false}
                            ApplyFilter={false}
                            suggestions={suggestions}
                            setSuggestions={setSuggestions}
                            toAddScreen={'/manage-admin-corporate/add-admin-corporate'}
                            setConfirmationState={setConfirmationState}
                            optimizedFn={optimizedFn}
                            data={data}
                            exportCols={['ID','Username','First Name','Last Name','Type','Status','Email Address','Mobile Number','Main Number','Created Date']}
                            isColumnSelect={isColumnSelect}
                            setIsColumnSelect={setIsColumnSelect}
                            exportUsers={exportUsers}

                            searchAdminCorporate={true}
                        />
                    </div>
                    {((isFetching&&status!=="fulfilled"&&status!=="rejected"&&!isSortselected)||(isLoading)||(data===undefined&&status!=="fulfilled"&&status!=="rejected"))?<CustomOverLay Active text="Loading admin/corporate list..." classKey={`absolute top-0 left-0 right-0  z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center  ${isSideBar?'opened_sidebar_overlay':'overlay-list'}`}/>: (data!==undefined && data?.data?.length > 0 ) ? <>
                        <div className="px-6">
                            <Table
                                pageNumber={Number(searchParams.get('page_number')) || 1}
                                List={data}
                                handleSearchParams={handleSearchParams}
                                sortValue={searchParams.get('sort') || ''}
                                setisSortSelected={setisSortSelected}
                                setConfirmationState={setConfirmationState}
                                setTextAreaMsg={setTextAreaMsg}
                            />
                        </div>
                        {data?.total_count>=15 &&<div className="w-[100%] px-2.5 py-1 flex items-center justify-between bg-[#F4F7FC] rounded-b-[8px]">
                            <p className="text-sm font-semibold text-[#687182]">Total Number of Records:{Math.ceil(parseInt(data?.total_count))}</p>
                            <div className="flex items-center">
                                <Limit
                                    limit={limit}
                                    setLimit={setLimit}
                                    handleNoOfRowsClick={handleNoOfRowsClick}
                                    isColumnSelect={isColumnSelect}
                                />
                        
                                <Pagination
                                    TotalCount={parseInt(data?.total_count)}
                                    totalPageNumber={Math.ceil(parseInt(data?.total_count)/parseInt(searchParams?.get("limit")))}
                                    handleOnClickPageNumber={handleOnClickPageNumber}
                                    // limit={Number(searchParams.get('limit'))}
                                    limit={parseInt(limit)}
                                />
                            </div>
                        </div>}
                    </>:<>
                        {(data?.total_count===0 &&suggestions?.trim()!=="")||(data?.success_status==="false") ?
                            <SearchEmptyScreen text={"No exact matches found. Please try a different search"} />
                            :
                            data?.total_count===0&&!searchParams.get("search")?<Emptyscreen
                                title={"Manage Admin/Corporate Users"}
                                FirstPTag={"No Admin/Corporate users added yet."}
                                SecondePTag={"Start managing by clicking Add User"}
                            />:((status==="rejected"||(data?.total_count!==0&&data?.data?.length===0))&&<SearchEmptyScreen text={"No data found"} />)
                        }
                    </>}
                </div>
                {confirmationState.isOpen  && 
                    <AnimatedModel 
                        Children={
                            <ConfirmationPrompt
                                emptyField={emptyField}
                                setEmptyField={setEmptyField}
                                setTextAreaMsg={setTextAreaMsg}
                                textAreaMsg={textAreaMsg}
                                handleOnCLickActivate={handleOnCLickActivate}
                                handleClose={handleConformationClick}
                                tittle= {confirmationState?.rowData!==""?confirmationState?.rowData?.status==="inactive"? 'Activate' : 'Deactivate':confirmationState.multirow==="active"?'Activate':'Deactivate'}
                                message = {confirmationState.rowData!==""?`Are you sure you want ${confirmationState?.rowData?.status==="inactive"? 'activate' : 'deactivate'} this ${confirmationState?.rowData?.user_type==='admin-user' ? 'admin' : 'corporate'}   user?`:
                                    `Are you sure you want to ${confirmationState.multirow==='active'?'activate':'deactivate'} the following users?`}
                                textMessage = {confirmationState.rowData!==""?confirmationState?.rowData?.status === 'inactive' ? true : false:confirmationState.multirow==="active"?true:false}
                                buttonName = {confirmationState.rowData!==""?confirmationState?.rowData?.status==="inactive"? 'Activate' : 'Deactivate':confirmationState.multirow==='active'?'Activate':'Deactivate'}
                                userList={confirmationState?.multirow===''?'':confirmationState?.multirow==="deactive"?(selectedRows?.filter((user)=>user.status!=='inactive'))?.map((item)=>item.name):(selectedRows?.filter((user)=>user.status!=='active'))?.map((item)=>item.name)}
                                loadingActivation={loading}
                            />
                        }
                    /> 
                }                
            </div>
            {isAdvancedSearchOpen&&searchParams?.get('limit')&&!searchParams?.get('target_user_name') &&
                <AdminCorporateAdvanceSearch
                    handleOnSubmit={handleOnSubmit}
                    emptyField={emptyField}
                    setEmptyField={setEmptyField}
                />
            }
            
        </>
   
    )
}